/*jshint ignore: start*/

//siema vanilla script slider
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define("Siema",[],t):"object"==typeof exports?exports.Siema=t():e.Siema=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(i[r])return i[r].exports;var n=i[r]={i:r,l:!1,exports:{}};return e[r].call(n.exports,n,n.exports,t),n.l=!0,n.exports}var i={};return t.m=e,t.c=i,t.d=function(e,i,r){t.o(e,i)||Object.defineProperty(e,i,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var i=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(i,"a",i),i},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,i){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s=function(){function e(e,t){for(var i=0;i<t.length;i++){var r=t[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,i,r){return i&&e(t.prototype,i),r&&e(t,r),t}}(),l=function(){function e(t){var i=this;if(r(this,e),this.config=e.mergeSettings(t),this.selector="string"==typeof this.config.selector?document.querySelector(this.config.selector):this.config.selector,null===this.selector)throw new Error("Something wrong with your selector 😭");this.resolveSlidesNumber(),this.selectorWidth=this.selector.offsetWidth,this.innerElements=[].slice.call(this.selector.children),this.currentSlide=this.config.loop?this.config.startIndex%this.innerElements.length:Math.max(0,Math.min(this.config.startIndex,this.innerElements.length-this.perPage)),this.transformProperty=e.webkitOrNot(),["resizeHandler","touchstartHandler","touchendHandler","touchmoveHandler","mousedownHandler","mouseupHandler","mouseleaveHandler","mousemoveHandler","clickHandler"].forEach(function(e){i[e]=i[e].bind(i)}),this.init()}return s(e,[{key:"attachEvents",value:function(){window.addEventListener("resize",this.resizeHandler),this.config.draggable&&(this.pointerDown=!1,this.drag={startX:0,endX:0,startY:0,letItGo:null,preventClick:!1},this.selector.addEventListener("touchstart",this.touchstartHandler),this.selector.addEventListener("touchend",this.touchendHandler),this.selector.addEventListener("touchmove",this.touchmoveHandler),this.selector.addEventListener("mousedown",this.mousedownHandler),this.selector.addEventListener("mouseup",this.mouseupHandler),this.selector.addEventListener("mouseleave",this.mouseleaveHandler),this.selector.addEventListener("mousemove",this.mousemoveHandler),this.selector.addEventListener("click",this.clickHandler))}},{key:"detachEvents",value:function(){window.removeEventListener("resize",this.resizeHandler),this.selector.removeEventListener("touchstart",this.touchstartHandler),this.selector.removeEventListener("touchend",this.touchendHandler),this.selector.removeEventListener("touchmove",this.touchmoveHandler),this.selector.removeEventListener("mousedown",this.mousedownHandler),this.selector.removeEventListener("mouseup",this.mouseupHandler),this.selector.removeEventListener("mouseleave",this.mouseleaveHandler),this.selector.removeEventListener("mousemove",this.mousemoveHandler),this.selector.removeEventListener("click",this.clickHandler)}},{key:"init",value:function(){this.attachEvents(),this.selector.style.overflow="hidden",this.selector.style.direction=this.config.rtl?"rtl":"ltr",this.buildSliderFrame(),this.config.onInit.call(this)}},{key:"buildSliderFrame",value:function(){var e=this.selectorWidth/this.perPage,t=this.config.loop?this.innerElements.length+2*this.perPage:this.innerElements.length;this.sliderFrame=document.createElement("div"),this.sliderFrame.style.width=e*t+"px",this.enableTransition(),this.config.draggable&&(this.selector.style.cursor="-webkit-grab");var i=document.createDocumentFragment();if(this.config.loop)for(var r=this.innerElements.length-this.perPage;r<this.innerElements.length;r++){var n=this.buildSliderFrameItem(this.innerElements[r].cloneNode(!0));i.appendChild(n)}for(var s=0;s<this.innerElements.length;s++){var l=this.buildSliderFrameItem(this.innerElements[s]);i.appendChild(l)}if(this.config.loop)for(var o=0;o<this.perPage;o++){var a=this.buildSliderFrameItem(this.innerElements[o].cloneNode(!0));i.appendChild(a)}this.sliderFrame.appendChild(i),this.selector.innerHTML="",this.selector.appendChild(this.sliderFrame),this.slideToCurrent()}},{key:"buildSliderFrameItem",value:function(e){var t=document.createElement("div");return t.style.cssFloat=this.config.rtl?"right":"left",t.style.float=this.config.rtl?"right":"left",t.style.width=(this.config.loop?100/(this.innerElements.length+2*this.perPage):100/this.innerElements.length)+"%",t.appendChild(e),t}},{key:"resolveSlidesNumber",value:function(){if("number"==typeof this.config.perPage)this.perPage=this.config.perPage;else if("object"===n(this.config.perPage)){this.perPage=1;for(var e in this.config.perPage)window.innerWidth>=e&&(this.perPage=this.config.perPage[e])}}},{key:"prev",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments[1];if(!(this.innerElements.length<=this.perPage)){var i=this.currentSlide;if(this.config.loop){if(this.currentSlide-e<0){this.disableTransition();var r=this.currentSlide+this.innerElements.length,n=this.perPage,s=r+n,l=(this.config.rtl?1:-1)*s*(this.selectorWidth/this.perPage),o=this.config.draggable?this.drag.endX-this.drag.startX:0;this.sliderFrame.style[this.transformProperty]="translate3d("+(l+o)+"px, 0, 0)",this.currentSlide=r-e}else this.currentSlide=this.currentSlide-e}else this.currentSlide=Math.max(this.currentSlide-e,0);i!==this.currentSlide&&(this.slideToCurrent(this.config.loop),this.config.onChange.call(this),t&&t.call(this))}}},{key:"next",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments[1];if(!(this.innerElements.length<=this.perPage)){var i=this.currentSlide;if(this.config.loop){if(this.currentSlide+e>this.innerElements.length-this.perPage){this.disableTransition();var r=this.currentSlide-this.innerElements.length,n=this.perPage,s=r+n,l=(this.config.rtl?1:-1)*s*(this.selectorWidth/this.perPage),o=this.config.draggable?this.drag.endX-this.drag.startX:0;this.sliderFrame.style[this.transformProperty]="translate3d("+(l+o)+"px, 0, 0)",this.currentSlide=r+e}else this.currentSlide=this.currentSlide+e}else this.currentSlide=Math.min(this.currentSlide+e,this.innerElements.length-this.perPage);i!==this.currentSlide&&(this.slideToCurrent(this.config.loop),this.config.onChange.call(this),t&&t.call(this))}}},{key:"disableTransition",value:function(){this.sliderFrame.style.webkitTransition="all 0ms "+this.config.easing,this.sliderFrame.style.transition="all 0ms "+this.config.easing}},{key:"enableTransition",value:function(){this.sliderFrame.style.webkitTransition="all "+this.config.duration+"ms "+this.config.easing,this.sliderFrame.style.transition="all "+this.config.duration+"ms "+this.config.easing}},{key:"goTo",value:function(e,t){if(!(this.innerElements.length<=this.perPage)){var i=this.currentSlide;this.currentSlide=this.config.loop?e%this.innerElements.length:Math.min(Math.max(e,0),this.innerElements.length-this.perPage),i!==this.currentSlide&&(this.slideToCurrent(),this.config.onChange.call(this),t&&t.call(this))}}},{key:"slideToCurrent",value:function(e){var t=this,i=this.config.loop?this.currentSlide+this.perPage:this.currentSlide,r=(this.config.rtl?1:-1)*i*(this.selectorWidth/this.perPage);e?requestAnimationFrame(function(){requestAnimationFrame(function(){t.enableTransition(),t.sliderFrame.style[t.transformProperty]="translate3d("+r+"px, 0, 0)"})}):this.sliderFrame.style[this.transformProperty]="translate3d("+r+"px, 0, 0)"}},{key:"updateAfterDrag",value:function(){var e=(this.config.rtl?-1:1)*(this.drag.endX-this.drag.startX),t=Math.abs(e),i=this.config.multipleDrag?Math.ceil(t/(this.selectorWidth/this.perPage)):1,r=e>0&&this.currentSlide-i<0,n=e<0&&this.currentSlide+i>this.innerElements.length-this.perPage;e>0&&t>this.config.threshold&&this.innerElements.length>this.perPage?this.prev(i):e<0&&t>this.config.threshold&&this.innerElements.length>this.perPage&&this.next(i),this.slideToCurrent(r||n)}},{key:"resizeHandler",value:function(){this.resolveSlidesNumber(),this.currentSlide+this.perPage>this.innerElements.length&&(this.currentSlide=this.innerElements.length<=this.perPage?0:this.innerElements.length-this.perPage),this.selectorWidth=this.selector.offsetWidth,this.buildSliderFrame()}},{key:"clearDrag",value:function(){this.drag={startX:0,endX:0,startY:0,letItGo:null,preventClick:this.drag.preventClick}}},{key:"touchstartHandler",value:function(e){-1!==["TEXTAREA","OPTION","INPUT","SELECT"].indexOf(e.target.nodeName)||(e.stopPropagation(),this.pointerDown=!0,this.drag.startX=e.touches[0].pageX,this.drag.startY=e.touches[0].pageY)}},{key:"touchendHandler",value:function(e){e.stopPropagation(),this.pointerDown=!1,this.enableTransition(),this.drag.endX&&this.updateAfterDrag(),this.clearDrag()}},{key:"touchmoveHandler",value:function(e){if(e.stopPropagation(),null===this.drag.letItGo&&(this.drag.letItGo=Math.abs(this.drag.startY-e.touches[0].pageY)<Math.abs(this.drag.startX-e.touches[0].pageX)),this.pointerDown&&this.drag.letItGo){e.preventDefault(),this.drag.endX=e.touches[0].pageX,this.sliderFrame.style.webkitTransition="all 0ms "+this.config.easing,this.sliderFrame.style.transition="all 0ms "+this.config.easing;var t=this.config.loop?this.currentSlide+this.perPage:this.currentSlide,i=t*(this.selectorWidth/this.perPage),r=this.drag.endX-this.drag.startX,n=this.config.rtl?i+r:i-r;this.sliderFrame.style[this.transformProperty]="translate3d("+(this.config.rtl?1:-1)*n+"px, 0, 0)"}}},{key:"mousedownHandler",value:function(e){-1!==["TEXTAREA","OPTION","INPUT","SELECT"].indexOf(e.target.nodeName)||(e.preventDefault(),e.stopPropagation(),this.pointerDown=!0,this.drag.startX=e.pageX)}},{key:"mouseupHandler",value:function(e){e.stopPropagation(),this.pointerDown=!1,this.selector.style.cursor="-webkit-grab",this.enableTransition(),this.drag.endX&&this.updateAfterDrag(),this.clearDrag()}},{key:"mousemoveHandler",value:function(e){if(e.preventDefault(),this.pointerDown){"A"===e.target.nodeName&&(this.drag.preventClick=!0),this.drag.endX=e.pageX,this.selector.style.cursor="-webkit-grabbing",this.sliderFrame.style.webkitTransition="all 0ms "+this.config.easing,this.sliderFrame.style.transition="all 0ms "+this.config.easing;var t=this.config.loop?this.currentSlide+this.perPage:this.currentSlide,i=t*(this.selectorWidth/this.perPage),r=this.drag.endX-this.drag.startX,n=this.config.rtl?i+r:i-r;this.sliderFrame.style[this.transformProperty]="translate3d("+(this.config.rtl?1:-1)*n+"px, 0, 0)"}}},{key:"mouseleaveHandler",value:function(e){this.pointerDown&&(this.pointerDown=!1,this.selector.style.cursor="-webkit-grab",this.drag.endX=e.pageX,this.drag.preventClick=!1,this.enableTransition(),this.updateAfterDrag(),this.clearDrag())}},{key:"clickHandler",value:function(e){this.drag.preventClick&&e.preventDefault(),this.drag.preventClick=!1}},{key:"remove",value:function(e,t){if(e<0||e>=this.innerElements.length)throw new Error("Item to remove doesn't exist 😭");var i=e<this.currentSlide,r=this.currentSlide+this.perPage-1===e;(i||r)&&this.currentSlide--,this.innerElements.splice(e,1),this.buildSliderFrame(),t&&t.call(this)}},{key:"insert",value:function(e,t,i){if(t<0||t>this.innerElements.length+1)throw new Error("Unable to inset it at this index 😭");if(-1!==this.innerElements.indexOf(e))throw new Error("The same item in a carousel? Really? Nope 😭");var r=t<=this.currentSlide>0&&this.innerElements.length;this.currentSlide=r?this.currentSlide+1:this.currentSlide,this.innerElements.splice(t,0,e),this.buildSliderFrame(),i&&i.call(this)}},{key:"prepend",value:function(e,t){this.insert(e,0),t&&t.call(this)}},{key:"append",value:function(e,t){this.insert(e,this.innerElements.length+1),t&&t.call(this)}},{key:"destroy",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=arguments[1];if(this.detachEvents(),this.selector.style.cursor="auto",e){for(var i=document.createDocumentFragment(),r=0;r<this.innerElements.length;r++)i.appendChild(this.innerElements[r]);this.selector.innerHTML="",this.selector.appendChild(i),this.selector.removeAttribute("style")}t&&t.call(this)}}],[{key:"mergeSettings",value:function(e){var t={selector:".siema",duration:200,easing:"ease-out",perPage:1,startIndex:0,draggable:!0,multipleDrag:!0,threshold:20,loop:!1,rtl:!1,onInit:function(){},onChange:function(){}},i=e;for(var r in i)t[r]=i[r];return t}},{key:"webkitOrNot",value:function(){return"string"==typeof document.documentElement.style.transform?"transform":"WebkitTransform"}}]),e}();t.default=l,e.exports=t.default}])});

//# sourceMappingURL=SmoothScroll.min.js.map
!function(){var e,t,o,n,r={frameRate:150,animationTime:400,stepSize:100,pulseAlgorithm:!0,pulseScale:4,pulseNormalize:1,accelerationDelta:50,accelerationMax:3,keyboardSupport:!0,arrowScroll:50,fixedBackground:!0,excluded:""},a=r,l=!1,i=!1,c={x:0,y:0},u=!1,s=document.documentElement,d=[],f=/^Mac/.test(navigator.platform),m={left:37,up:38,right:39,down:40,spacebar:32,pageup:33,pagedown:34,end:35,home:36},h={37:1,38:1,39:1,40:1};function w(){if(!u&&document.body){u=!0;var n=document.body,r=document.documentElement,c=window.innerHeight,d=n.scrollHeight;if(s=document.compatMode.indexOf("CSS")>=0?r:n,e=n,a.keyboardSupport&&A("keydown",S),top!=self)i=!0;else if(Z&&d>c&&(n.offsetHeight<=c||r.offsetHeight<=c)){var f,m=document.createElement("div");m.style.cssText="position:absolute; z-index:-10000; top:0; left:0; right:0; height:"+s.scrollHeight+"px",document.body.appendChild(m),o=function(){f||(f=setTimeout(function(){l||(m.style.height="0",m.style.height=s.scrollHeight+"px",f=null)},500))},setTimeout(o,10),A("resize",o);if((t=new q(o)).observe(n,{attributes:!0,childList:!0,characterData:!1}),s.offsetHeight<=c){var h=document.createElement("div");h.style.clear="both",n.appendChild(h)}}a.fixedBackground||l||(n.style.backgroundAttachment="scroll",r.style.backgroundAttachment="scroll")}}var p=[],v=!1,y=Date.now();function b(e,t,o){var n,r;if(n=(n=t)>0?1:-1,r=(r=o)>0?1:-1,(c.x!==n||c.y!==r)&&(c.x=n,c.y=r,p=[],y=0),1!=a.accelerationMax){var l=Date.now()-y;if(l<a.accelerationDelta){var i=(1+50/l)/2;i>1&&(i=Math.min(i,a.accelerationMax),t*=i,o*=i)}y=Date.now()}if(p.push({x:t,y:o,lastX:t<0?.99:-.99,lastY:o<0?.99:-.99,start:Date.now()}),!v){var u=V(),s=e===u||e===document.body;null==e.$scrollBehavior&&function(e){var t=M(e);if(null==B[t]){var o=getComputedStyle(e,"")["scroll-behavior"];B[t]="smooth"==o}return B[t]}(e)&&(e.$scrollBehavior=e.style.scrollBehavior,e.style.scrollBehavior="auto");var d=function(n){for(var r=Date.now(),l=0,i=0,c=0;c<p.length;c++){var u=p[c],f=r-u.start,m=f>=a.animationTime,h=m?1:f/a.animationTime;a.pulseAlgorithm&&(h=I(h));var w=u.x*h-u.lastX>>0,y=u.y*h-u.lastY>>0;l+=w,i+=y,u.lastX+=w,u.lastY+=y,m&&(p.splice(c,1),c--)}s?window.scrollBy(l,i):(l&&(e.scrollLeft+=l),i&&(e.scrollTop+=i)),t||o||(p=[]),p.length?R(d,e,1e3/a.frameRate+1):(v=!1,null!=e.$scrollBehavior&&(e.style.scrollBehavior=e.$scrollBehavior,e.$scrollBehavior=null))};R(d,e,0),v=!0}}function g(t){u||w();var o=t.target;if(t.defaultPrevented||t.ctrlKey)return!0;if(K(e,"embed")||K(o,"embed")&&/\.pdf/i.test(o.src)||K(e,"object")||o.shadowRoot)return!0;var r=-t.wheelDeltaX||t.deltaX||0,l=-t.wheelDeltaY||t.deltaY||0;f&&(t.wheelDeltaX&&P(t.wheelDeltaX,120)&&(r=t.wheelDeltaX/Math.abs(t.wheelDeltaX)*-120),t.wheelDeltaY&&P(t.wheelDeltaY,120)&&(l=t.wheelDeltaY/Math.abs(t.wheelDeltaY)*-120)),r||l||(l=-t.wheelDelta||0),1===t.deltaMode&&(r*=40,l*=40);var c=L(o);return c?!!function(e){if(!e)return;d.length||(d=[e,e,e]);e=Math.abs(e),d.push(e),d.shift(),clearTimeout(n),n=setTimeout(function(){try{localStorage.SS_deltaBuffer=d.join(",")}catch(e){}},1e3);var t=e>120&&$(e);return!$(120)&&!$(100)&&!t}(l)||(Math.abs(r)>1.2&&(r*=a.stepSize/120),Math.abs(l)>1.2&&(l*=a.stepSize/120),b(c,r,l),t.preventDefault(),void C()):!i||!U||(Object.defineProperty(t,"target",{value:window.frameElement}),parent.wheel(t))}function S(t){var o=t.target,n=t.ctrlKey||t.altKey||t.metaKey||t.shiftKey&&t.keyCode!==m.spacebar;document.body.contains(e)||(e=document.activeElement);var r=/^(button|submit|radio|checkbox|file|color|image)$/i;if(t.defaultPrevented||/^(textarea|select|embed|object)$/i.test(o.nodeName)||K(o,"input")&&!r.test(o.type)||K(e,"video")||function(e){var t=e.target,o=!1;if(-1!=document.URL.indexOf("www.youtube.com/watch"))do{if(o=t.classList&&t.classList.contains("html5-video-controls"))break}while(t=t.parentNode);return o}(t)||o.isContentEditable||n)return!0;if((K(o,"button")||K(o,"input")&&r.test(o.type))&&t.keyCode===m.spacebar)return!0;if(K(o,"input")&&"radio"==o.type&&h[t.keyCode])return!0;var l=0,c=0,u=L(e);if(!u)return!i||!U||parent.keydown(t);var s=u.clientHeight;switch(u==document.body&&(s=window.innerHeight),t.keyCode){case m.up:c=-a.arrowScroll;break;case m.down:c=a.arrowScroll;break;case m.spacebar:c=-(t.shiftKey?1:-1)*s*.9;break;case m.pageup:c=.9*-s;break;case m.pagedown:c=.9*s;break;case m.home:u==document.body&&document.scrollingElement&&(u=document.scrollingElement),c=-u.scrollTop;break;case m.end:var d=u.scrollHeight-u.scrollTop-s;c=d>0?d+10:0;break;case m.left:l=-a.arrowScroll;break;case m.right:l=a.arrowScroll;break;default:return!0}b(u,l,c),t.preventDefault(),C()}function x(t){e=t.target}var k,D,M=(k=0,function(e){return e.uniqueID||(e.uniqueID=k++)}),E={},T={},B={};function C(){clearTimeout(D),D=setInterval(function(){E=T=B={}},1e3)}function H(e,t,o){for(var n=o?E:T,r=e.length;r--;)n[M(e[r])]=t;return t}function z(e,t){return(t?E:T)[M(e)]}function L(e){var t=[],o=document.body,n=s.scrollHeight;do{var r=z(e,!1);if(r)return H(t,r);if(t.push(e),n===e.scrollHeight){var a=X(s)&&X(o)||Y(s);if(i&&O(s)||!i&&a)return H(t,V())}else if(O(e)&&Y(e))return H(t,e)}while(e=e.parentElement)}function O(e){return e.clientHeight+10<e.scrollHeight}function X(e){return"hidden"!==getComputedStyle(e,"").getPropertyValue("overflow-y")}function Y(e){var t=getComputedStyle(e,"").getPropertyValue("overflow-y");return"scroll"===t||"auto"===t}function A(e,t,o){window.addEventListener(e,t,o||!1)}function N(e,t,o){window.removeEventListener(e,t,o||!1)}function K(e,t){return e&&(e.nodeName||"").toLowerCase()===t.toLowerCase()}if(window.localStorage&&localStorage.SS_deltaBuffer)try{d=localStorage.SS_deltaBuffer.split(",")}catch(e){}function P(e,t){return Math.floor(e/t)==e/t}function $(e){return P(d[0],e)&&P(d[1],e)&&P(d[2],e)}var j,R=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(e,t,o){window.setTimeout(e,o||1e3/60)},q=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver,V=(j=document.scrollingElement,function(){if(!j){var e=document.createElement("div");e.style.cssText="height:10000px;width:1px;",document.body.appendChild(e);var t=document.body.scrollTop;document.documentElement.scrollTop,window.scrollBy(0,3),j=document.body.scrollTop!=t?document.body:document.documentElement,window.scrollBy(0,-3),document.body.removeChild(e)}return j});function F(e){var t,o;return(e*=a.pulseScale)<1?t=e-(1-Math.exp(-e)):(e-=1,t=(o=Math.exp(-1))+(1-Math.exp(-e))*(1-o)),t*a.pulseNormalize}function I(e){return e>=1?1:e<=0?0:(1==a.pulseNormalize&&(a.pulseNormalize/=F(1)),F(e))}var _=window.navigator.userAgent,W=/Edge/.test(_),U=/chrome/i.test(_)&&!W,G=/safari/i.test(_)&&!W,J=/mobile/i.test(_),Q=/Windows NT 6.1/i.test(_)&&/rv:11/i.test(_),Z=G&&(/Version\/8/i.test(_)||/Version\/9/i.test(_)),ee=(U||G||Q)&&!J,te=!1;try{window.addEventListener("test",null,Object.defineProperty({},"passive",{get:function(){te=!0}}))}catch(e){}var oe=!!te&&{passive:!1},ne="onwheel"in document.createElement("div")?"wheel":"mousewheel";function re(e){for(var t in e)r.hasOwnProperty(t)&&(a[t]=e[t])}ne&&ee&&(A(ne,g,oe),A("mousedown",x),A("load",w)),re.destroy=function(){t&&t.disconnect(),N(ne,g),N("mousedown",x),N("keydown",S),N("resize",o),N("load",w)},window.SmoothScrollOptions&&re(window.SmoothScrollOptions),"function"==typeof define&&define.amd?define(function(){return re}):"object"==typeof exports?module.exports=re:window.SmoothScroll=re}();

/*!
 * imagesLoaded PACKAGED v4.1.3
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
!function(e,t){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",t):"object"==typeof module&&module.exports?module.exports=t():e.EvEmitter=t()}("undefined"!=typeof window?window:this,function(){function e(){}var t=e.prototype;return t.on=function(e,t){if(e&&t){var i=this._events=this._events||{},n=i[e]=i[e]||[];return-1==n.indexOf(t)&&n.push(t),this}},t.once=function(e,t){if(e&&t){this.on(e,t);var i=this._onceEvents=this._onceEvents||{},n=i[e]=i[e]||{};return n[t]=!0,this}},t.off=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){var n=i.indexOf(t);return-1!=n&&i.splice(n,1),this}},t.emitEvent=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){var n=0,o=i[n];t=t||[];for(var r=this._onceEvents&&this._onceEvents[e];o;){var s=r&&r[o];s&&(this.off(e,o),delete r[o]),o.apply(this,t),n+=s?0:1,o=i[n]}return this}},t.allOff=t.removeAllListeners=function(){delete this._events,delete this._onceEvents},e}),function(e,t){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return t(e,i)}):"object"==typeof module&&module.exports?module.exports=t(e,require("ev-emitter")):e.imagesLoaded=t(e,e.EvEmitter)}("undefined"!=typeof window?window:this,function(e,t){function i(e,t){for(var i in t)e[i]=t[i];return e}function n(e){var t=[];if(Array.isArray(e))t=e;else if("number"==typeof e.length)for(var i=0;i<e.length;i++)t.push(e[i]);else t.push(e);return t}function o(e,t,r){return this instanceof o?("string"==typeof e&&(e=document.querySelectorAll(e)),this.elements=n(e),this.options=i({},this.options),"function"==typeof t?r=t:i(this.options,t),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(function(){this.check()}.bind(this))):new o(e,t,r)}function r(e){this.img=e}function s(e,t){this.url=e,this.element=t,this.img=new Image}var h=e.jQuery,a=e.console;o.prototype=Object.create(t.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(e){"IMG"==e.nodeName&&this.addImage(e),this.options.background===!0&&this.addElementBackgroundImages(e);var t=e.nodeType;if(t&&d[t]){for(var i=e.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=e.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var d={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(e){var t=getComputedStyle(e);if(t)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(t.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,e),n=i.exec(t.backgroundImage)}},o.prototype.addImage=function(e){var t=new r(e);this.images.push(t)},o.prototype.addBackground=function(e,t){var i=new s(e,t);this.images.push(i)},o.prototype.check=function(){function e(e,i,n){setTimeout(function(){t.progress(e,i,n)})}var t=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(t){t.once("progress",e),t.check()}):void this.complete()},o.prototype.progress=function(e,t,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!e.isLoaded,this.emitEvent("progress",[this,e,t]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,e),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,e,t)},o.prototype.complete=function(){var e=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(e,[this]),this.emitEvent("always",[this]),this.jqDeferred){var t=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[t](this)}},r.prototype=Object.create(t.prototype),r.prototype.check=function(){var e=this.getIsImageComplete();return e?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&void 0!==this.img.naturalWidth},r.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.img,t])},r.prototype.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var e=this.getIsImageComplete();e&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.element,t])},o.makeJQueryPlugin=function(t){t=t||e.jQuery,t&&(h=t,h.fn.imagesLoaded=function(e,t){var i=new o(this,e,t);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});

/*jshint ignore: end*/

(function () {
    if ( typeof NodeList.prototype.forEach === "function" ) return false;
    NodeList.prototype.forEach = Array.prototype.forEach;
})();

(function($) {


  $("body").children().each(function() {
      $(this).html($(this).html().replace(/&#8232 ;/g," ")); // remove the space in front of the first semicolon!
  });



  // ############
  // HERO VIDEO
  // ############
  var timeoutId;
  var $videoBgAspect = $(".videobg-aspect");
  var $videoBgWidth = $(".videobg-width");
  var videoAspect = $videoBgAspect.outerHeight() / $videoBgAspect.outerWidth();

  function videobgEnlarge() {
    var windowAspect = ($(window).height() / $(window).width());
    if (windowAspect > videoAspect) {
      $videoBgWidth.width((windowAspect / videoAspect) * 110 + '%');
    } else {
      $videoBgWidth.width(110 + "%");
    }
  }

  $(window).on('resize',function() {
    videobgEnlarge();
  });
  videobgEnlarge();


  if( $('.videobg iframe').length > 0 ){
    var iframe = $('.videobg iframe');
    var player = new Vimeo.Player(iframe);


    player.ready().then(function() {
      setTimeout(function(){ $('.videobg').removeClass('is-faded'); }, 1000);
    });

    player.on('ended', function() {
        console.log('Finished.');
        $('.video--wrapper').addClass('is-faded');
        $('.videobg').addClass('is-faded');
    });

    // player.on('error', function() {
    //   console.log('error');
    //   jQuery('.videobg').addClass('is-faded');
    // });
  }



  // ############
  // GLOBAL VARS - ES6 SCRIPTING STARTS
  // ############
  const body = document.querySelector('body'),
        pageContent = document.querySelector('#page-content');


  //smooth scrolling
  $('a[href*=\\#]').on('click', function(event){
      event.preventDefault();
      console.log(this.hash);
      $('html,body').animate({scrollTop:$(this.hash).offset().top - 180}, 500);
  });


  let $anchorLinks = document.querySelectorAll('.list--anchor li');
  $anchorLinks.forEach(function(el){

    el.addEventListener('click',function(){
      let activeElement = document.querySelector('.list--anchor .is-active');
      if( activeElement ){
        activeElement.classList.remove('is-active');
      }
      this.classList.add('is-active');
    });


  });



  //js-directory-jump
  const directoryJump = document.querySelector('.page--nav__mobile select');
  if( directoryJump ){
    directoryJump.addEventListener('change',function(el){
      window.location = this.value;
    });
  }


  //hamburger
  const hamburgerFunc = function(){
    const hamBurger = document.querySelector('.hamburger');
    hamBurger.addEventListener('click',function(){
      body.classList.toggle('is-nav-open');


      const menuItemWithChildren = document.querySelectorAll('.menu-item-has-children');

      Array.from(menuItemWithChildren).forEach(function(el){
        el.addEventListener('click',function(){
          console.log(this);
          this.classList.toggle('is-open');
        });
      });

    });
  };
  hamburgerFunc();


  //accordion
  const accordionFunc = function(){
    const accordionTitle = document.querySelectorAll('.h--accordion__title');
    Array.from(accordionTitle).forEach(function(el){
      const accordionItem = el.parentElement;
      el.addEventListener('click',function(){
        const accordionOpen = document.querySelector('.h--accordion__item.is-open');
        if( accordionOpen ){
          accordionItem.classList.add('is-open');
          accordionOpen.classList.remove('is-open');
        }else{
          accordionItem.classList.add('is-open');
        }
      });
    });

    //global accordion function
    $('.h--accordion__item').each(function(){
      var accordTitle = $(this).find('.h--accordion__title'),
          accordContent = $(this).find('.h--accordion__content');
      accordTitle.on('click',function(){
          var theOffset = $(this).offset().top - 200;
          $('html, body').animate({
            scrollTop: theOffset
          }, 600);
      });
    });
  };
  accordionFunc();



  //slider in vehicle single
  const sliderFunc = function(){
    const timeLineItems = document.querySelectorAll('.vehicle--gallery__item'),
          siemaSlider = document.querySelector('.vehicle--gallery'),
          slideNavItems = document.querySelectorAll('.vehicle--gallery__nav-item');
    if( siemaSlider ){

    const mySiema = new Siema({
      selector: siemaSlider,
      duration: 200,
      easing: 'ease-out',
      perPage: 1,
      startIndex: 0,
      draggable: true,
      multipleDrag: true,
      threshold: 20,
      loop: false,
      rtl: false,
      onChange: function(){
        //on change setup
        var self = this;
        timeLineItems.forEach(function(el){
          el.classList.remove('is-active');
          self.innerElements[self.currentSlide].classList.add('is-active');
        });
        slideNavItems.forEach(function(el){
          el.classList.remove('is-active');
          var thisNavItem = document.querySelector('.vehicle--gallery__nav-item.nav-item-'+self.currentSlide);
              thisNavItem.classList.add('is-active');
        });
      },
      onInit: function(){
        //init setup
        var currentSlide = this.currentSlide + 1;
        this.innerElements[this.currentSlide].classList.add('is-active');
        slideNavItems.forEach(function(el,i){
          el.addEventListener('click', () => mySiema.goTo(i,function(){

          }));
        });
      }
    });
    }
  };
  sliderFunc ();


  // scroll events parallax stuff
  const parallaxFunc = function(){
    var windowHeight = window.innerHeight,
        gridTop = windowHeight * 1.5;

    // Faster scrolling animation
    // Detect request animation frame
    var scroll = window.requestAnimationFrame ||
                 window.webkitRequestAnimationFrame ||
                 window.mozRequestAnimationFrame ||
                 window.msRequestAnimationFrame ||
                 window.oRequestAnimationFrame ||
                 // IE Fallback, you can even fallback to onscroll
                 function(callback){ window.setTimeout(callback, 1000/60); };

    var lastPosition = -1;

    //fixie clippy vars - hero
    var projectRow = document.querySelectorAll('.featured--unclipped .section');

    function loop(){

        // Avoid calculations if not needed
        if (lastPosition === window.pageYOffset) {
          scroll(loop);
          return false;
        } else {
          lastPosition = window.pageYOffset;
        }

        //slide text anim
        const rows = document.querySelectorAll('.js-animated');
        Array.from(rows).forEach(function(el){
          var rowLastTop = el.offsetTop - lastPosition,
              rowLastBot = el.offsetTop + el.offsetHeight - lastPosition;
          if( rowLastTop >= gridTop && ( rowLastTop + el.offsetHeight ) <= rowLastBot ){
            setTimeout(function(){
              el.classList.remove('is-row-hit');
            },600);
          }else{
            setTimeout(function(){
              el.classList.add('is-row-hit');
            },600);
          }
        });

        //stickynavs
        // const stickyNavWrapper = document.querySelector('.list--anchor__wrapper'),
        //       stickyNav = document.querySelector('.list--anchor'),
        //       headerHeight = document.querySelector('.header--wrapper'),
        //       stickyNavLastTop = stickyNavWrapper.offsetTop - lastPosition;


        // if( stickyNavWrapper && stickyNavLastTop <= headerHeight.clientHeight ){
        //   stickyNav.classList.add('is--fixed');
        // }else{
        //   stickyNav.classList.remove('is--fixed');
        // }

        //slide text anim
        const filterList = document.querySelector('.list--anchor__wrapper');
        if( filterList ){
          var rowLastTop = filterList.offsetTop - lastPosition,
              rowLastBot = filterList.offsetTop + filterList.offsetHeight - lastPosition,
              rowTop = filterList.offsetTop,
              sectionHeight = 0,
              navHeight = document.querySelector('.header--wrapper').offsetHeight;


              if( document.querySelector('.featured--unclipped') ){
                sectionHeight = document.querySelector('.featured--unclipped').offsetHeight;
              }else if( document.querySelector('.featured--banner') ){
                sectionHeight = document.querySelector('.featured--banner').offsetHeight;
              }


          if( rowLastTop <= navHeight ){
            filterList.classList.add('is-row-hit');
          }
          if( lastPosition <= sectionHeight ){
            filterList.classList.remove('is-row-hit');
          }
        }


        //parallax stuff
        $('.js-parallax').each(function(i){
          var slideObject = $(this),
              slideOffset = parseInt( slideObject.offset().top ),
              parallaxSpeed = $(this).data('speed'),
              parallaxYpos;
          parallaxYpos = ( ( slideOffset - lastPosition ) / parallaxSpeed * 0.90 );

          if( $(this).data('type') === 'img' ){
            slideObject.css({
              'transform': 'translateY('+parallaxYpos+'px)'
            });
          } else if( $(this).data('type') === 'bg') {
              slideObject.css({
                'background-position' : 'center ' + parallaxYpos+'px',
              });
          }
        });


        // //parallax effect
        // const jsParallax = document.querySelectorAll('.js-parallax');
        // Array.from(jsParallax).forEach(function(el){
        //   var slideOffset = parseInt(el.offsetTop),
        //       parallaxSpeed = el.dataset.speed,
        //       parallaxYPos = ( (slideOffset - lastPosition) / parallaxSpeed * 0.90 );

        //   //insert data-speed in dom that will parallax
        //   el.setAttribute('style','transform:translateY('+ parallaxYPos +'px)');
        // });

        //my clippy effect - hero
        projectRow.forEach(function(el,i){
          i++;
          let projectRowLastTop = Math.round(el.offsetTop - lastPosition),
            projectRowLastBot = Math.round(el.offsetTop + el.clientHeight - lastPosition ),
            projectHeaderClip = document.querySelector('.featured--clipped .section:nth-child('+i+')');

          if( projectHeaderClip ){
            projectHeaderClip.setAttribute('style','clip:rect('+ projectRowLastTop + 'px,' + el.clientWidth + 'px,' + projectRowLastBot +'px,0px)');
          }
        });


        scroll( loop );
    }
    // Call the loop for the first time
    loop();
  };
  parallaxFunc();



})(jQuery); // Fully reference jQuery after this point.

//VUE APPLICATIONS START - will need to transfer this to its own file
function remove(array, element) {
    const index = array.indexOf(element);
    if (index !== -1) {
        array.splice(index, 1);
    }
}

function intersection() {
  var result = [];
  var lists;

  if(arguments.length === 1) {
    lists = arguments[0];
  } else {
    lists = arguments;
  }

  for(var i = 0; i < lists.length; i++) {
    var currentList = lists[i];
    for(var y = 0; y < currentList.length; y++) {
      var currentValue = currentList[y];
      if(result.indexOf(currentValue) === -1) {
        if(lists.filter(function(obj) { return obj.indexOf(currentValue) == -1 }).length == 0) {
          result.push(currentValue);
        }
      }
    }
  }
  return result;
}


const routes = [
  {
    path: '/vehicles/:cat',
    name: 'Vehicles',
    component: vehiclePosts
  },
]
const router = new VueRouter({
  mode: 'history',
  routes
});

var searchParams = new URLSearchParams(window.location.search);
var paramCon =  searchParams.getAll('con')[0];
var paramCap =  searchParams.getAll('cap')[0];
var paramCat =  searchParams.getAll('cat')[0];
var paramS =  searchParams.getAll('search')[0];
var vcondition;
var vcap;
var vcat;
var vs;

console.log(paramS);

if(paramCon){
    vcondition = paramCon;
}else{
    vcondition = 'all';
}
if(paramCap){
    vcap = paramCap;
}else{
    vcap = 'all';
}
if(paramCat){
    vcat = paramCat;
}else{
    vcat = 'all';
}
if(paramS){
    vs = paramS;
}else{
    vs = '';
}


var vehiclePosts = new Vue({
  el: '#vehicle--app',
  router,
  data: {
    vposts: [],
    vcats: [],
    selectedCondition: [],
    selectedCapacity: [],
    selectedCategory: [],
    enteredSearchText: [],
    filterResult: [],
    vehicle_condition: vcondition,
    vehicle_capacity: vcap,
    vehicle_category: vcat,
    vehicle_search: vs
  },
  created(){
    //initial setup
    this.fetchPosts();
    this.fetchCategory();
  },
  mounted(){
    if(paramCon){
        this.filterConditionFunc();
    }
    if(paramCap){
        this.filterCapacityFunc();
    }
    if(paramCat){
        this.filterCategoryFunc();
    }
    if(paramS){
        this.filterSearchFunc();
    }
    //this.filterCategoryFunc();
    //this.filterCapacityFunc();
  },
  methods: {
    //store functions

    showImage(post) {
        if( post.featured_image_src ){
          //let imageFull = post._embedded['wp:featuredmedia'][0].media_details.sizes.grid_thumbnail.source_url;
          let imageFull = post.featured_image_src;
          return imageFull;
        }
    },

    showImageW(post) {
        if( post.featured_image_width ){
          //let imageFull = post._embedded['wp:featuredmedia'][0].media_details.sizes.grid_thumbnail.source_url;
          let imageFull = post.featured_image_width;
          return imageFull;
        }
    },
    showImageH(post) {
        if( post.featured_image_height ){
          //let imageFull = post._embedded['wp:featuredmedia'][0].media_details.sizes.grid_thumbnail.source_url;
          let imageFull = post.featured_image_height;
          return imageFull;
        }
    },
    //?_embed&filter[meta_key]=last_name&filter[orderby]=meta_value&filter[order]=asc&per_page=90&

    fetchPosts: function(){
      var self = this;
      var d = new Date();
      var n = d.getMinutes();
      fetch('/wp-json/my_endpoint/v1/my_post_type?v='+n,{ credentials: 'include', cache: 'no-cache' })
      .then(function(response){
        return response.json();
      })
      .then(function(myJson){
        self.vposts = myJson;
      });
    },

    //store functions
    fetchCategory: function(){
      var self = this;
      fetch('/wp-json/wp/v2/vehicle_category',{ credentials: 'include', cache: 'no-cache' })
      .then(function(response){
        return response.json();
      })
      .then(function(myJson){
        myJson.forEach(function(element) {
          if( element.count > 0 ){
            self.vcats.push(element);
          }
        });
      });
    },

    filterConditionFunc: function(){
      var self = this,
          search = this.vehicle_search,
          condition = this.vehicle_condition,
          capacity = this.vehicle_capacity,
          capacityArr = capacity.split(',');

      var d = new Date();
      var n = d.getMinutes();

         if( self.vposts.length <= 0 ){
          fetch('/wp-json/my_endpoint/v1/my_post_type?v='+n,{ credentials: 'include', cache: 'no-cache' })
          .then(function(response){
            return response.json();
          })
          .then(function(myJson){

            var thePosts = myJson;
            self._self.$el.classList.remove('loading');

            if( condition !== 'all' ){
              thePosts.forEach(function(vpost){
                if( vpost.acf_condition.includes(condition)){
                  const indexCon = self.selectedCondition.indexOf(vpost.ID);
                  if( indexCon > -1 ){
                    self.selectedCondition.splice(indexCon, 1);
                  }else{
                    self.selectedCondition.push(vpost.ID);
                  }
                }else{
                  remove(self.selectedCondition, vpost.ID);
                }
              });
            }else{

              console.log(thePosts);

              thePosts.forEach(function(vpost){
                self.selectedCondition.push(vpost.ID);
              });
            }

          });

         }else{
            var thePosts = self.vposts;
            if( condition !== 'all' ){
              thePosts.forEach(function(vpost){
                if( vpost.acf_condition.includes(condition)){
                  const indexCon = self.selectedCondition.indexOf(vpost.ID);
                  if( indexCon > -1 ){
                    self.selectedCondition.splice(indexCon, 1);
                  }else{
                    self.selectedCondition.push(vpost.ID);
                  }
                }else{
                  remove(self.selectedCondition, vpost.ID);
                }
              });
            }else{
              thePosts.forEach(function(vpost){
                self.selectedCondition.push(vpost.ID);
              });
            }
         }
    },

    filterSearchFunc: function(){
      var self = this,
          search = this.vehicle_search,
          condition = this.vehicle_condition,
          capacity = this.vehicle_capacity,
          capacityArr = capacity.split(',');

      var d = new Date();
      var n = d.getMinutes();

         if( self.vposts.length <= 0 ){
          fetch('/wp-json/my_endpoint/v1/my_post_type?v='+n,{ credentials: 'include', cache: 'no-cache' })
          .then(function(response){
            return response.json();
          })
          .then(function(myJson){

            var thePosts = myJson;
            self._self.$el.classList.remove('loading');

            if( search !== '' ){
              thePosts.forEach(function(vpost){
                if( vpost.post_title.toLowerCase().includes(search.toLowerCase()) || vpost.acf_unit.toLowerCase().includes(search.toLowerCase()) ){
                  const indexS = self.enteredSearchText.indexOf(vpost.ID);
                  if( indexS > -1 ){
                    //self.enteredSearchText.splice(indexS, 1);
                  }else{
                    self.enteredSearchText.push(vpost.ID);
                  }
                }else{
                  remove(self.enteredSearchText, vpost.ID);
                }
              });
            }else{

              console.log(thePosts);

              thePosts.forEach(function(vpost){
                self.enteredSearchText.push(vpost.ID);
              });

            }

          });

         }else{
            var thePosts = self.vposts;
            if( search !== '' ){
              thePosts.forEach(function(vpost){
                if( vpost.post_title.toLowerCase().includes(search.toLowerCase()) || vpost.acf_unit.toLowerCase().includes(search.toLowerCase()) ){
                  const indexS = self.enteredSearchText.indexOf(vpost.ID);
                  if( indexS > -1 ){
                    //self.enteredSearchText.splice(indexS, 1);
                  }else{
                    self.enteredSearchText.push(vpost.ID);
                  }
                }else{
                  remove(self.enteredSearchText, vpost.ID);
                }
              });
            }else{
              thePosts.forEach(function(vpost){
                self.enteredSearchText.push(vpost.ID);
              });
            }
         }
    },

    filterCapacityFunc: function(){
      var self = this,
          search = this.vehicle_search,
          capacity = this.vehicle_capacity,
          capacityArr = capacity.split(',');

      var d = new Date();
      var n = d.getMinutes();

          if( self.vposts.length <= 0 ){

            fetch('/wp-json/my_endpoint/v1/my_post_type?v='+n,{ credentials: 'include', cache: 'no-cache' })
            .then(function(response){
              return response.json();
            })
            .then(function(myJson){
              var thePosts = myJson;
              self._self.$el.classList.remove('loading');

              if( capacity !== 'all' ){
                thePosts.forEach(function(vpost){
                  if( vpost.acf_capacity >= Number(capacityArr[0]) && vpost.acf_capacity <= Number(capacityArr[1]) ){
                    const indexCap = self.selectedCapacity.indexOf(vpost.ID);
                    if( indexCap > -1 ){
                      self.selectedCapacity.splice(indexCap, 1);
                    }else{
                      self.selectedCapacity.push(vpost.ID);
                    }
                  }else{
                    remove(self.selectedCapacity, vpost.ID);
                  }
                });
              }else{
                thePosts.forEach(function(vpost){
                  self.selectedCapacity.push(vpost.ID);
                });
              }
            });

          }else{

            var thePosts = self.vposts;
            if( capacity !== 'all' ){
              thePosts.forEach(function(vpost){
                if( vpost.acf_capacity >= Number(capacityArr[0]) && vpost.acf_capacity <= Number(capacityArr[1]) ){
                  const indexCap = self.selectedCapacity.indexOf(vpost.ID);
                  if( indexCap > -1 ){
                    self.selectedCapacity.splice(indexCap, 1);
                  }else{
                    self.selectedCapacity.push(vpost.ID);
                  }
                }else{
                  remove(self.selectedCapacity, vpost.ID);
                }
              });
            }else{
              thePosts.forEach(function(vpost){
                self.selectedCapacity.push(vpost.ID);
              });
            }

          }
    },


    filterCategoryFunc: function(){
      var self = this,
          search = this.vehicle_search,
          category = Number(this.vehicle_category);



      var d = new Date();
      var n = d.getMinutes();

          if( self.vposts.length <= 0 ){
            fetch('/wp-json/my_endpoint/v1/my_post_type?v='+n,{ credentials: 'include', cache: 'no-cache' })
            .then(function(response){
              return response.json();
            })
            .then(function(myJson){
              var thePosts = myJson;
              self._self.$el.classList.remove('loading');
              if( category !== 'all' ){
                thePosts.forEach(function(vpost){
                  if(vpost.vehicle_category == category){
                    const indexCat = self.selectedCategory.indexOf(vpost.ID);
                    if( indexCat > -1 ){
                      self.selectedCategory.splice(indexCat, 1);
                    }else{
                      self.selectedCategory.push(vpost.ID);
                    }
                  }else{
                    remove(self.selectedCategory, vpost.ID);
                  }
                });
              }else{
                thePosts.forEach(function(vpost){
                  self.selectedCategory.push(vpost.ID);
                });
              }
            });

          }else{
            var thePosts = self.vposts;

            if( category !== 'all' ){
              thePosts.forEach(function(vpost){

                //console.log(vpost.vehicle_category);

                if(vpost.vehicle_category == category ){
                  const indexCat = self.selectedCategory.indexOf(vpost.ID);
                  if( indexCat > -1 ){
                    self.selectedCategory.splice(indexCat, 1);
                  }else{
                    self.selectedCategory.push(vpost.ID);
                  }
                }else{
                  remove(self.selectedCategory, vpost.ID);
                }
              });
            }else{
              thePosts.forEach(function(vpost){
                self.selectedCategory.push(vpost.ID);
              });
            }
          }
    },

  },
  computed: {
    //computed
    filteredPosts: function (){

      var selectedCond = this.selectedCondition,
          selectedCap = this.selectedCapacity,
          selectedCat = this.selectedCategory,
          enteredSearch = this.enteredSearchText,
          self = this;


        if( self.vehicle_condition === 'all' && self.vehicle_capacity === 'all' && self.vehicle_category === 'all' && self.vehicle_search === '' ){
          //self.isFirst(self.vposts);
          self._self.$el.classList.remove('loading');
          return self.vposts;
        }else{
          self._self.$el.classList.remove('loading');
          return self.vposts.filter(function(post){

            //clear
            self.filterResult = [];
            var unique;
            if( self.vehicle_condition !== 'all' && self.vehicle_capacity !== 'all' && self.vehicle_category !== 'all' && self.vehicle_search !== '' ){
              //find intersect in arrays
              unique = intersection([selectedCond, selectedCap, selectedCat, enteredSearch]);
              console.log(unique);
              if( unique.includes(post.ID) ){
                self.filterResult.push(post);
                return self.filterResult;
              }
            }else{
              if( self.vehicle_condition !== 'all' && self.vehicle_capacity !== 'all' && self.vehicle_category === 'all' && self.vehicle_search !== '' ){
                //find intersect in arrays
                unique = intersection([selectedCond, selectedCap, enteredSearch]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition !== 'all' && self.vehicle_capacity === 'all' && self.vehicle_category !== 'all' && self.vehicle_search !== '' ){
                //find intersect in arrays
                unique = intersection([selectedCond, selectedCat, enteredSearch]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition === 'all' && self.vehicle_capacity !== 'all' && self.vehicle_category !== 'all' && self.vehicle_search !== '' ){
                //find intersect in arrays
                unique = intersection([selectedCat, selectedCap, enteredSearch]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition !== 'all' && self.vehicle_capacity !== 'all' && self.vehicle_category !== 'all' && self.vehicle_search === '' ){
                //find intersect in arrays
                unique = intersection([selectedCat, selectedCap, selectedCond]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition !== 'all' && self.vehicle_capacity === 'all' && self.vehicle_category !== 'all' && self.vehicle_search !== '' ){
                //find intersect in arrays
                unique = intersection([selectedCat, selectedCond, enteredSearch]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition !== 'all' && self.vehicle_capacity !== 'all' && self.vehicle_category === 'all' && self.vehicle_search !== '' ){
                //find intersect in arrays
                unique = intersection([selectedCap, selectedCond, enteredSearch]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition === 'all' && self.vehicle_capacity !== 'all' && self.vehicle_category !== 'all' && self.vehicle_search !== '' ){
                //find intersect in arrays
                unique = intersection([selectedCap, selectedCat, enteredSearch]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition === 'all' && self.vehicle_capacity === 'all' && self.vehicle_category !== 'all' && self.vehicle_search !== '' ){
                //find intersect in arrays
                unique = intersection([selectedCat, enteredSearch]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition === 'all' && self.vehicle_capacity !== 'all' && self.vehicle_category === 'all' && self.vehicle_search !== '' ){
                //find intersect in arrays
                unique = intersection([selectedCap, enteredSearch]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition === 'all' && self.vehicle_capacity !== 'all' && self.vehicle_category !== 'all' && self.vehicle_search === '' ){
                //find intersect in arrays
                unique = intersection([selectedCap, selectedCat]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition !== 'all' && self.vehicle_capacity === 'all' && self.vehicle_category === 'all' && self.vehicle_search !== '' ){
                //find intersect in arrays
                unique = intersection([selectedCond, enteredSearch]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition !== 'all' && self.vehicle_capacity === 'all' && self.vehicle_category !== 'all' && self.vehicle_search === '' ){
                //find intersect in arrays
                unique = intersection([selectedCond, selectedCat]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition !== 'all' && self.vehicle_capacity !== 'all' && self.vehicle_category === 'all' && self.vehicle_search === '' ){
                //find intersect in arrays
                unique = intersection([selectedCond, selectedCap]);
                if( unique.includes(post.ID) ){
                  self.filterResult.push(post);
                  return self.filterResult;
                }
              }else if( self.vehicle_condition !== 'all' && self.vehicle_capacity === 'all' && self.vehicle_category === 'all' && self.vehicle_search === '' ){
                //find intersect in arrays;
                if( selectedCond.includes(post.ID)){
                  self.filterResult.push(post);
                  return self.filterResult.push(post);
                }
              }else if( self.vehicle_condition === 'all' && self.vehicle_capacity !== 'all' && self.vehicle_category === 'all' && self.vehicle_search === '' ){
                //find intersect in arrays
                if( selectedCap.includes(post.ID)){
                  self.filterResult.push(post);
                  return self.filterResult.push(post);
                }
              }else if( self.vehicle_condition === 'all' && self.vehicle_capacity === 'all' && self.vehicle_category !== 'all' && self.vehicle_search === '' ){
                //find intersect in arrays
                if( selectedCat.includes(post.ID)){
                  self.filterResult.push(post);
                  return self.filterResult.push(post);
                }
              }else if( self.vehicle_condition === 'all' && self.vehicle_capacity === 'all' && self.vehicle_category === 'all' && self.vehicle_search !== '' ){
                //find intersect in arrays
                if( enteredSearch.includes(post.ID)){
                  self.filterResult.push(post);
                  return self.filterResult.push(post);
                }
              }
            }
          });
        }
    }
  }

});

var vehicleHomeFilter = new Vue({
    el: '#vehicle-home--filter',
    data: {
      vcats: [],
      vcaps: [
        { value: '1,10', name: '1 - 10' },
        { value: '11,24', name: '11 - 24'},
        { value: '25,100', name: '25 - 100'},
      ],
      vconds: [
        { value: 'new', name: 'New'},
        { value: 'preowned', name: 'Pre-Owned'},
      ],
      vehicle_search:'',
      vehicle_category:'all',
      vehicle_capacity:'all',
      vehicle_condition:'all',
      vehicle_category_sel:'All',
      vehicle_capacity_sel:'All',
      vehicle_condition_sel:'All',
    },
    created(){
      this.fetchCategory();
      this.getVal();
    },
    methods: {
      //store functions
      fetchCategory: function(){
        var selfCategory = this;
        fetch('/wp-json/wp/v2/vehicle_category',{ credentials: 'include' })
        .then(function(response){
          return response.json();
        })
        .then(function(myJson){
          selfCategory.vcats = myJson;
        });
      },
      getVal: function(value){

      	let getSiblings = function (e) {
            // for collecting siblings
            let siblings = []; 
            // if no parent, return no sibling
            if(!e.parentNode) {
                return siblings;
            }
            // first child of the parent node
            let sibling  = e.parentNode.firstChild;
            // collecting siblings
            while (sibling) {
                if (sibling.nodeType === 1 && sibling !== e) {
                    siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
            }
            return siblings;
        };

        const catRefs = this.$refs['vehicle_cat_ref'],
              capRefs = this.$refs['vehicle_cap_ref'],
              condRefs = this.$refs['vehicle_con_ref'],
              catAll = document.querySelector('.cat-all'),
              capAll = document.querySelector('.cap-all'),
              condAll = document.querySelector('.cond-all'),
              self = this;

        if( self.vehicle_category == 'all' ){
          self.vehicle_category_sel = 'All';
          if (typeof(catAll) != 'undefined' && catAll != null){
          	catAll.classList.add('hide');
          }
          if( catRefs ){
            catRefs.forEach(function(catRef){
                catRef.parentElement.parentElement.classList.remove('hide');
            });
          }
        } else {
          if( catRefs ){
            catRefs.forEach(function(catRef){
              if( catRef.getAttribute('value') == self.vehicle_category ){
                self.vehicle_category_sel = catRef.parentElement.textContent;
                catRef.parentElement.parentElement.classList.add('hide');
              }else{
              	//catRef.parentElement.parentElement.classList.remove('is--active');
                catRef.parentElement.parentElement.classList.remove('hide');
                if (typeof(catAll) != 'undefined' && catAll != null){
		          	catAll.classList.remove('hide');
		        }
              }
            });
          }
        }


        if( self.vehicle_capacity == 'all' ){
          self.vehicle_capacity_sel = 'All';
          if (typeof(capAll) != 'undefined' && capAll != null){
          	capAll.classList.add('hide');
          }
          if( capRefs ){
            capRefs.forEach(function(capRef){
                capRef.parentElement.parentElement.classList.remove('hide');
            });
          }
        } else {
          if( capRefs ){
            capRefs.forEach(function(capRef){
              if( capRef.getAttribute('value') == self.vehicle_capacity ){
                self.vehicle_capacity_sel = capRef.parentElement.textContent;
                capRef.parentElement.parentElement.classList.add('hide');
              }else{
                //capRef.parentElement.parentElement.classList.remove('is--active');
                capRef.parentElement.parentElement.classList.remove('hide');
                if (typeof(capAll) != 'undefined' && capAll != null){
		          	capAll.classList.remove('hide');
		        }
              }
            });
          }
        }


        if( self.vehicle_condition == 'all' ){
          self.vehicle_condition_sel = 'All';
          if (typeof(condAll) != 'undefined' && condAll != null){
          	condAll.classList.add('hide');
          }
          if( condRefs ){
            condRefs.forEach(function(condRef){
                condRef.parentElement.parentElement.classList.remove('hide');
            });
          }
        } else {
          if( condRefs ){
            condRefs.forEach(function(condRef){
              console.log(condRef);

              if( condRef.getAttribute('value') == self.vehicle_condition ){
                self.vehicle_condition_sel = condRef.parentElement.textContent;
                condRef.parentElement.parentElement.classList.add('hide');
              }else{
                //condRef.parentElement.parentElement.classList.remove('is--active');
                condRef.parentElement.parentElement.classList.remove('hide');
                if (typeof(condAll) != 'undefined' && condAll != null){
		          	condAll.classList.remove('hide');
		        }
              }
            });
          }
        }
      },

    },
  });

   //home filter
  var homeFilterItems = document.querySelectorAll('#vehicle-home--filter .col-dropdown');
  homeFilterItems.forEach(function(el){

    el.addEventListener('mouseenter',function(){
      this.classList.add('is-open');
      this.previousElementSibling.classList.add('open-prev');
    });
    el.addEventListener('mouseleave',function(){
      this.classList.remove('is-open');
      this.previousElementSibling.classList.remove('open-prev');
    });

    el.addEventListener('click',function(){
      this.classList.remove('is-open');
      this.previousElementSibling.classList.remove('open-prev');
    });

  });


  var mobileFilterOpen = document.querySelector('.mobile--filter__open'),
      mobileFilterClose = document.querySelectorAll('.js-mobile--filter__close'),
      body = document.querySelector('body');

      if( mobileFilterOpen ){
        mobileFilterOpen.addEventListener('click',function(){
          body.classList.add('is-filter-open');

          Array.from(mobileFilterClose).forEach(function(el){
            el.addEventListener('click',function(){
              body.classList.remove('is-filter-open');
            });
          });

        });
      }

  //sales inquiries
  const salesInquiriesFunc = function(){
    const salesButton = document.querySelectorAll('.js--sales-inquiries');
    Array.from(salesButton).forEach(function(el){
      el.addEventListener('click',function(evt){
        evt.preventDefault();
        body.classList.add('is-sales-modal-open');

        var vehicle = this.dataset.vehicle;
        var modalSales = document.querySelector('.js--modal-sales');
        var vehicleInput = modalSales.querySelector('.Vehicle input');
        if( vehicle ){
          //console.log(vehicle);
          vehicleInput.value = vehicle;
        }else{
          if( vehicleInput ){
            vehicleInput.classList.add('is--hidden');
          }
        }


        const mobileSalesClose = document.querySelector('.js--modal-sales .mobile--filter__close');
        const bgClose = document.querySelector('.js--modal-bg');


        if( mobileSalesClose ){
          mobileSalesClose.addEventListener('click',function(){
            body.classList.remove('is-sales-modal-open');
            if ( vehicleInput ){
              vehicleInput.classList.remove('is--hidden');
              vehicleInput.value = '';
            }
          });
          bgClose.addEventListener('click',function(){
            body.classList.remove('is-sales-modal-open');
            if ( vehicleInput ){
              vehicleInput.classList.remove('is--hidden');
              vehicleInput.value = '';
            }
          });
        }
      });
    });
  };
  salesInquiriesFunc();

  const partsInquiriesFunc = function(){
    const partsButton = document.querySelectorAll('.js--parts-inquiries');
    Array.from(partsButton).forEach(function(el){
      el.addEventListener('click',function(evt){
        evt.preventDefault();
        body.classList.add('is-parts-modal-open');

        var vehicle = this.dataset.vehicle;
        var modalSales = document.querySelector('.js--modal-parts');
        var vehicleInput = modalSales.querySelector('.Vehicle input');
        if( vehicle ){
          //console.log(vehicle);
          vehicleInput.value = vehicle;
        }else{
          if( vehicleInput ){
            vehicleInput.classList.add('is--hidden');
          }
        }


        const mobileSalesClose = document.querySelector('.js--modal-parts .mobile--filter__close');
        const bgClose = document.querySelector('.js--modal-bg');


        if( mobileSalesClose ){
          mobileSalesClose.addEventListener('click',function(){
            body.classList.remove('is-parts-modal-open');
            if ( vehicleInput ){
              vehicleInput.classList.remove('is--hidden');
              vehicleInput.value = '';
            }
          });
          bgClose.addEventListener('click',function(){
            body.classList.remove('is-parts-modal-open');
            if ( vehicleInput ){
              vehicleInput.classList.remove('is--hidden');
              vehicleInput.value = '';
            }
          });
        }
      });
    });
  };
  partsInquiriesFunc();

